export const getDeclarationUrl = ({
    manifestId,
    jobId,
    declarationId,
}: {
    manifestId?: string | number;
    jobId?: string | number;
    declarationId?: string | number;
}) => {
    const isManifests = Boolean(manifestId && jobId);
    return isManifests ? `/manifests/${manifestId}/${jobId}/${declarationId}` : `/declarations/${declarationId}`;
};
